module.exports = __webpack_public_path__ + "files/2c56c30f284d29d40190df2ce397ffd5.svg";